<template>
	<div
		class="c-height-wrapper"
		:style="{
			height,
		}"
	>
		<div ref="detector">
			<slot></slot>
		</div>
	</div>
</template>

<script>
export default defineComponent({
	name: 'HeightWrapper',

	data() {
		return {
			resizeObserver: null,
      mutationObserver: null,
			height: 'auto',
		};
	},

	mounted() {
		const { detector } = this.$refs;

		this.resizeObserver = new ResizeObserver(() => {
      this.getSetHeight();
      nextTick(() => {
        this.getSetHeight();
      });
    });
    this.mutationObserver = new MutationObserver(() => {
      this.getSetHeight();
      nextTick(() => {
        this.getSetHeight();
      });
    });

		this.resizeObserver.observe(detector);
    this.mutationObserver.observe(detector, {
      childList: true,
      attributes: true,
      subtree: true,
    });
	},

  beforeUnmount() {
    this.resizeObserver?.disconnect?.();
    this.mutationObserver?.disconnect?.();
  },

  methods: {
    getSetHeight() {
      const { detector } = this.$refs;

      let top = Infinity;
      let bottom = -Infinity;

      [...detector.children].forEach(child => {
        const position = window.getComputedStyle(child).getPropertyValue('position');
        if (['static', 'relative', 'sticky'].includes(position)) {
          const { top: childTop, bottom: childBottom } = child.getBoundingClientRect();
          top = Math.min(top, childTop);
          bottom = Math.max(bottom, top + child.offsetHeight, childBottom);
        }
      });

      const height = bottom - top;
      this.height = `${height}px`;
    },
  },
});
</script>

<style lang="postcss">
:where(.c-height-wrapper > div) {
	width: auto;
	height: auto;
  min-width: 100%;
  min-height: 100%;
}
</style>
